<!--  -->
<template>
  <div class='indexHeader'>
    <div>
      <div class="indexTop">
        <div>{{$route.meta.title}}</div>
        <!-- <el-tooltip placement="left-start" effect="light">
          <div slot="content">
            <img src="@/assets/code/ruzhu.jpg" width="120" alt="">
            <div class="piaofu">
              <p>前往嗨团商家入驻</p>
              <p>微信小程序</p>
            </div>
          </div>
          <div class="flexView">
            <img src="@/assets/phone.png" class="phoneImg" alt="">
            <span style="color: #666;">去微信小程序，使用嗨团商家入驻</span>
          </div>
        </el-tooltip> -->
      </div>
      <div class="indexTop">
        <div class="lefMsg">
          <div class="userMsg">
            <div>{{userInfo.companyName}}</div>
          </div>
          <div class="flexView">
            <div>联系人：{{userInfo.contactsPerson	}}</div>
            <div>电话：{{userInfo.phone}}</div>
            <div>职位：{{userInfo.position}}</div>
            <div>状态：{{userInfo.statusDes}}</div>
          </div>
          <div class="jujue" v-if="userInfo.status === 3">
            拒绝原因：{{userInfo.remark}}
          </div>
        </div>
        <div class="flexView">
          <div class="goodsMsg">
            <div>营业执照</div>
            <div>
              <el-image :src="userInfo.businessPic" fit="contain" :preview-src-list="[userInfo.businessPic]"></el-image>
            </div>
          </div>
          <div class="goodsMsg">
            <div>第二类医疗器械经营备案</div>
            <div>
              <el-image :src="userInfo.managePic" fit="contain" :preview-src-list="[userInfo.managePic]"></el-image>
            </div>
          </div>
          <div class="goodsMsg">
            <div>第二类医疗器械生产备案</div>
            <div>
              <el-image :src="userInfo.productionPic" fit="contain" :preview-src-list="[userInfo.productionPic]"></el-image>
            </div>
          </div>
          <!-- <div class="goodsMsg">
            <div>第二类医疗器械产品备案</div>
            <div>
              <el-image :src="userInfo.productPic" fit="contain" :preview-src-list="[userInfo.productPic]"></el-image>
            </div>
          </div> -->
          <div class="goodsMsg goodsMsg1" v-if="userInfo.supplyLinks && userInfo.supplyLinks.length">
            <div>补充资料</div>
            <div class="ziliao">
              <el-popover placement="right" title="补充资料"  trigger="manual" v-model="visible">
                <img slot="reference" width="80" @click="visible = !visible" src="@/assets/look.png">
                <div>
                  <div v-for="item in userInfo.supplyLinks" :key="item" style="margin: 20px 35px">
                    <el-image v-if="checkImg(item)" :src="item" style="width: 80px" fit="contain" :preview-src-list="userInfo.supplyLinks"></el-image>
                    <div v-else class="ziliao" style="margin-left: 0">
                      <a :href="item" target="_blank">
                        <div>文件</div>
                        <div class="smallFont">（点击查看）</div>
                      </a>
                    </div>
                  </div>
                </div>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkImg } from "../utils/utils";
export default {
  props: ['userInfo'],
  components: {},
  data() {
    return {
      visible: false
    }
  },
  computed: {},
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
  
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  methods: {
    checkImg
  },
}
</script>
<style lang='scss'>
.indexHeader {
  background: #fff;
  > div {
    padding: 5px;
    width: 1400px;
    margin: 0 auto;
    .indexTop {
      padding:6px 0;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .avatar {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    margin-right: 20px;
  }
  .userMsg {
    display: flex;
    flex-direction: column;
    // justify-content: space-around;
    > :first-child {
      font-size: 20px;
    }
    > :last-child {
      padding: 6px 0;
      // color: #999;
    }
  }
  
  .goodsMsg {
    position: relative;
    width: 150px;
    text-align: right;
    line-height: 34px;
    font-size: 12px;
    > :first-child {
      color: #999;
    }
    .el-image {
      width: 80px;
      height: 80px;
    }
  }
  //
  .goodsMsg:not(:last-of-type)::after {
    position: absolute;
    content: '';
    border-right: 1px solid #ddd;
    top: 16px;
    right: -10px;
    height: 55px;
  }
  .goodsMsg1 {
    width: 100px !important;
    height: 126px;
    flex: 0;
  }
  .phoneImg {
    height: 17px;
    width: auto;
    margin-right: 10px;
  }

  img {
    width: 80px;
    height: 80px;
  }

}


.is-light {
  border: 1px solid #f5f5f5 !important;
}

.piaofu {
  margin-top: 6px;
  text-align: center;
  color: #666;
  font-size: 10px;
}
.lefMsg {
  width: 800px;
  height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .jujue {
    color: red;
    font-weight: bold;
  }
}
.flexView {
  > div {
    flex: 1;
  }
}
.ziliao {
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #f5f5f5;
  margin-left: 30px;
  text-align: center;
  font-size: 12px;
  margin-top: -2px;
  a {
    text-decoration: none !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 80px;
    line-height: 30px;
  }
}
</style>